const integrations = {
  metadata: {
    required: "Preencha os campos obrigatórios antes de conectar esta ferramenta.",
    tab: "Metadados",
    valuePlaceholder: "valor",
  },
  models: {
    problem: {
      emptyName: "Há um modelo sem nome.",
      duplicate: "{{model}}: nome repetido.",
      missingApi: "{{model}}: escolha a rota.",
      missingDimensions: "{{model}}: informe as dimensões (tamanho do vetor).",
      invalidDimensions: "{{model}}: as dimensões devem ser um número inteiro positivo.",
    },
    empty: "Nenhum modelo cadastrado.",
    add: "Adicionar modelo",
    remove: "Remover modelo",
    namePlaceholder: "nome do modelo ou deployment",
    apiPlaceholder: "rota",
    apiVersionPlaceholder: "api-version",
    apiVersionSuspect:
      "Este valor não tem o formato de data que os provedores usam na api-version. Confira antes de salvar.",
    apiVersionHint:
      "A api-version é a versão da API REST do provedor, não a versão do modelo que aparece no portal dele. Ela vale só para este modelo: rotas diferentes do mesmo recurso podem exigir versões diferentes.",
    dimensionsPlaceholder: "dimensões",
    serves: "atende o modelo {{model}}",
    invalid: "Revise os modelos: cada um precisa de nome e rota, e os de indexação precisam das dimensões.",
  },
  title: "Tools",
  description: "Integre todas suas ferramentas em um só lugar",
  empty: {
    title: "Nenhuma ferramenta encontrada",
    description: "Configure uma nova ferramenta para começar"
  },
  new: {
    title: "Nova ferramenta",
    description: "Configure uma nova ferramenta"
  },
  form: {
    name: "Nome",
    description: "Descrição",
    type: "Tipo",
    status: "Status",
    authType: "Tipo de Autenticação",
    selectAuthType: "Selecione um tipo de autenticação",
    title: {
      label: "Nome da ferramenta",
      placeholder: "Ex: Jira da Squad Mobile",
      required: "O nome da ferramenta é obrigatório"
    },
    errors: {
      requiredFields: "Campos obrigatórios não preenchidos: {{fields}}",
      create: "Erro ao criar ferramenta. Verifique os dados e tente novamente.",
      update: "Erro ao atualizar ferramenta. Verifique os dados e tente novamente.",
      unknown: "Erro desconhecido"
    },
    defaultDescription: "Ferramenta configurada via Prodgy"
  },
  status: {
    active: "Ativa",
    inactive: "Inativa",
    pending: "Pendente",
    failed: "Falha",
    connected: "Conectada",
    disconnected: "Desconectada",
    syncing: "Sincronizando",
    synced: "Sincronizada",
    unknown: "Desconhecido"
  },
  fields: {
    apiKey: "Chave da API",
    model: "Modelo",
    clientId: "ID do Cliente",
    clientSecret: "Chave Secreta do Cliente",
    accessToken: "Token de Acesso",
    redirectUri: "URI de Redirecionamento",
    privateToken: "Token Privado",
    gitlabUrl: "URL do GitLab",
    gitlabProjectId: "ID do Projeto GitLab",
    organization: "Organização",
    googleProjectId: "ID do Projeto Google",
    username: "Usuário",
    password: "Senha",
    scope: "Escopo",
    apiKeyPlaceholder: "Digite sua chave da API OpenRouter",
    modelPlaceholder: "Digite o nome do modelo (ex: openai/gpt-4)",
    clientIdPlaceholder: "Digite o ID do Cliente",
    clientSecretPlaceholder: "Digite a Chave Secreta do Cliente",
    accessTokenPlaceholder: "Digite o Token de Acesso",
    redirectUriPlaceholder: "Digite a URI de Redirecionamento",
    privateTokenPlaceholder: "Digite o Token Privado",
    gitlabUrlPlaceholder: "Digite a URL do GitLab",
    gitlabProjectIdPlaceholder: "Digite o ID do Projeto GitLab",
    organizationPlaceholder: "Digite o nome da Organização",
    googleProjectIdPlaceholder: "Digite o ID do Projeto Google",
    usernamePlaceholder: "Digite o usuário",
    passwordPlaceholder: "Digite a senha",
    scopePlaceholder: "Digite o escopo"
  },
  actions: {
    connect: "Conectar",
    disconnect: "Desconectar",
    save: "Salvar alterações",
    cancel: "Cancelar",
    test: "Testar conexão",
    sync: "Sincronizar",
    update: "Atualizar",
    connecting: "Conectando...",
    updating: "Atualizando...",
    remove: "Remover",
    configure: "Configurar"
  },
  messages: {
    connected: "Ferramenta conectada com sucesso",
    disconnected: "Ferramenta desconectada com sucesso",
    saved: "Alterações salvas com sucesso",
    error: "Erro ao processar a operação",
    authUpdated: "Configurações de autenticação atualizadas com sucesso",
    authUpdateError: "Falha ao atualizar configurações de autenticação",
    connectionTestFailed: "Teste de conexão falhou. Por favor, verifique suas credenciais e tente novamente.",
    cannotDelete: "Não é possível remover ferramenta",
    deleteSuccess: "foi removido com sucesso!",
    deleteError: "Erro ao remover ferramenta. Tente novamente.",
    hasDependencies: "Esta ferramenta está sendo usada por {{dependencies}}. Remova essas dependências antes de excluir a ferramenta."
  },
  searchPlaceholder: "Pesquise por ferramentas...",
  searchTools: "Pesquise por ferramentas...",
  addIntegration: "Adicionar ferramenta",
  add: "Adicionar",
  encrypted: "Criptografado",
  configure: "Configurar",
  lastValidated: "Última validação",
  selectTemplate: "Selecione a ferramenta que deseja integrar ao Prodgy",
  select: "Selecionar",
  sections: {
    settings: "Configurações",
    authentication: "Autenticação"
  },
  placeholders: {
    select: "Selecione...",
    enterField: "Digite {{field}}"
  },
  defaultFields: {
    integrationName: "Nome da ferramenta",
    integrationNamePlaceholder: "Digite um nome para esta ferramenta",
    apiKeyToken: "API Key/Token"
  },
  editDialog: {
    edit: "Editar",
    editTitle: "Editar {{name}}",
    updateSettings: "Atualize as configurações e credenciais da ferramenta",
    configureIntegration: "Configure a ferramenta"
  },
  scope: {
    label: "Escopo",
    addTo: "Adicionar a ferramenta a...",
    workspaceOnly: "Somente ao workspace",
    globalAll: "Toda a organização",
    sectionWorkspace: "Do Workspace",
    sectionOrganization: "De toda a organização",
    missingOrg: "Não foi possível identificar a organização atual.",
    missingWorkspace: "Selecione um workspace ou marque a ferramenta como global.",
    permissionsLabel: "Permissões",
    productLabel: "Produto",
    organizationLabel: "Organização",
    organizationHint: "Esta ferramenta ficará disponível para uso em todos os produtos da organização.",
    productHint: "Esta ferramenta terá uso restrito apenas ao produto atual e substituirá a versão da organização, se houver.",
    product: "Este produto",
    general: "Global"
  },
  postInstall: {
    title: "Ferramenta criada — próximos passos",
    subtitle: "Configure {{name}} usando os valores abaixo e siga as instruções para concluir a instalação.",
    copied: "URL copiada",
    copyFailed: "Falha ao copiar",
    copy: "Copiar",
    instructionsLabel: "Instruções de configuração",
    confirm: "Entendi",
    manifestLabel: "App Manifest",
    copyManifest: "Copiar JSON",
    downloadZip: "Baixar ZIP",
    zipBuilding: "Gerando...",
    zipFailed: "Falha ao gerar o pacote ZIP"
  },
   delete: {
    title: "Remover ferramenta",
    confirmMessage: "Tem certeza de que deseja remover a ferramenta <strong>{{name}}</strong>?",
    warning: "Esta ação não pode ser desfeita. Todas as configurações e credenciais serão permanentemente perdidas.",
    removing: "Removendo...",
    confirm: "Sim, Remover"
  },
  selector: {
    noIntegrations: "Nenhuma ferramenta",
    noToolsFound: "Nenhuma ferramenta encontrada",
    resultCount_one: "{{count}} ferramenta",
    resultCount_other: "{{count}} ferramentas",
    filtered_one: "filtrada",
    filtered_other: "filtradas",
    forQuery: "para \"{{query}}\"",
    requiredNotInstalled: "A ferramenta exigida pelo fluxo não está instalada",
    addNewPrompt: "Ou adicione uma nova ferramenta...",
    addFirstPrompt: "Adicione uma ferramenta para começar...",
    templateDescription: "Template de ferramenta"
  }
} as const;

export default integrations;
